import { render, staticRenderFns } from "./testingTable.vue?vue&type=template&id=6b482a2a&"
import script from "./testingTable.vue?vue&type=script&lang=js&"
export * from "./testingTable.vue?vue&type=script&lang=js&"
import style0 from "./testingTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports